<template>
  <div>
    <v-dialog v-model="dialog.form" 
      persistent
      width="500">
      <v-card class="border-radius box-shadow">
        <v-card-title class="body-2 white--text light-green lighten-2 text-capitalize">
          {{ form.company.id.length > 0 ? 'Ubah' : 'Tambah' }} Bank {{ menu[selected.menu].value }}
        </v-card-title>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-form class="pt-5 pb-0" v-if="menu[selected.menu].value === 'company'">
              <ValidationProvider name="Pilih Bank" rules="required" v-slot="{ errors }">
                <v-select
                  dense
                  outlined
                  single-line
                  label="Pilih Bank Company"
                  :color="style.primary"
                  prepend-inner-icon="mdi-bank"
                  :items="master"
                  item-value="bank_id"
                  item-text="bank_name"
                  item-color="light-green lighten-2"
                  v-model="form.company.bank_id"
                  :error-messages="errors"
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                   <template v-slot:selection="data">
                    <v-avatar left tile class="mr-2">
                      <v-img contain :src="data.item.ref_bank_image"></v-img>
                    </v-avatar>
                    {{ data.item.bank_name }}
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile>
                        <v-img contain :src="data.item.ref_bank_image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.bank_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </ValidationProvider>
              <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                <v-text-field
                  dense
                  outlined
                  label="Nama Pemilik"
                  prepend-inner-icon="mdi-card-account-details-outline"
                  :color="style.primary"
                  v-model="form.company.bank_account_name"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
              <ValidationProvider name="No Rekening" rules="required" v-slot="{ errors }">
                <v-text-field
                  type="number"
                  dense
                  outlined
                  label="No Rekening"
                  prepend-inner-icon="mdi-numeric"
                  :color="style.primary"
                  v-model="form.company.bank_account_number"
                  :error-messages="errors"
                  require>
                </v-text-field>
              </ValidationProvider>
            </v-form>

            <v-form class="pt-5 pb-0" v-if="menu[selected.menu].value === 'kpr'">
              <ValidationProvider name="Pilih Bank" rules="required" v-slot="{ errors }">
                <v-select
                  dense
                  outlined
                  single-line
                  label="Pilih Bank KPR"
                  :color="style.primary"
                  prepend-inner-icon="mdi-bank"
                  :items="master"
                  item-value="bank_id"
                  item-text="bank_name"
                  item-color="light-green lighten-2"
                  v-model="form.kpr.bank_id"
                  :error-messages="errors"
                  require>
                  <template v-slot:append>
                    <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                  </template>
                   <template v-slot:selection="data">
                    <v-avatar left tile class="mr-2">
                      <v-img contain :src="data.item.ref_bank_image"></v-img>
                    </v-avatar>
                    {{ data.item.bank_name }}
                  </template>
                  <template v-slot:item="data">
                    <template>
                      <v-list-item-avatar tile>
                        <v-img contain :src="data.item.ref_bank_image"></v-img>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title v-html="data.item.bank_name"></v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-form>
          </ValidationObserver>
          <v-alert 
            class="mx-10 mt-10"
            type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-divider class="mx-4 my-2"/>
        <v-card-actions class="pa-5">
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="save">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Simpan
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="reset(); $refs.observer.reset();">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tutup
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.delete" 
      persistent
      width="400">
      <v-card class="pa-5">
        <v-card-text>
          Apakah anda yakin menghapus
          <span class="font-weight-bold">
            {{ detail.ref_bank_company_bank_account_name }}
          </span>
          ?
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            color="red"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="deletes">
            <v-icon small class="mr-1">mdi-trash-can-outline</v-icon>
            Ya, hapus
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="detail = {}; dialog.delete = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog.status" 
      persistent
      width="400">
      <v-card class="pa-5">
        <v-card-text>
          Apakah anda yakin 
          {{ detail.ref_bank_kpr_status === '1' ? 'menonaktifkan' : 'mengaktifkan' }}
          <span class="font-weight-bold">
            {{ detail.ref_bank_kpr_bank_name }} ?
          </span>
        </v-card-text>
        <v-card-text class="pt-0 pb-0">
          <v-alert type="error" text dense prominent 
            v-show="error.message.length > 0"
            v-html="error.message">
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            small
            :color="style.primary"
            elevation="3"
            class="text-capitalize white--text mx-1"
            :loading="process.form"
            :disabled="process.form"
            @click="statuses">
            <v-icon small class="mr-1">mdi-check</v-icon>
            Ya, {{ detail.ref_bank_kpr_status === '1' ? 'nonaktifkan' : 'aktifkan' }}
          </v-btn>
          <v-btn
            small
            outlined
            class="text-capitalize red--text mx-1"
            :disabled="process.form"
            @click="detail = {}; dialog.status = false;">
            <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
            Tidak
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

     <v-dialog v-model="sorting.show"
      class="hidden-md-and-up"
      fullscreen 
      hide-overlay 
      transition="dialog-bottom-transition">
       <v-card 
        flat
        color="#f9f9f9">
          <v-card-text class="py-0 pl-0 pr-0">
            <v-toolbar dark :color="style.primary">
              <v-btn icon dark @click="sorting.show = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            <v-toolbar-title>Filter</v-toolbar-title>
          <div class="flex-grow-1"></div>
          </v-toolbar>
            <v-card-text class="text-second text-left pb-0" style="font-size: 12px;">
              Anda bisa menambahkan bank baik untuk company atau KPR.
            </v-card-text>
            <v-card-text class="text-third text-left" style="font-size: 12px;">
              Silahkan pilih bank :
            </v-card-text>

            <v-list dense class="pa-0 border-item">
              <v-list-item-group
                v-model="selected.menu"
                no-action
                active-class="white--text">
                <template v-for="(item, index) in menu">
                  <v-list-item :key="index"
                    :class="{
                      'actived': selected.menu === index
                    }"
                    @click="sorting.show = false">
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-content class="pa-0">
                        <v-list-item-title class="text-left text-second caption">
                          {{ item.label }}
                        </v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>

                  <v-divider/>
                </template>
              </v-list-item-group>
            </v-list>
          </v-card-text>
       </v-card>
     </v-dialog>
    
    <!-- <v-container class="py-0"> -->
      <v-row>
        <v-col cols="12" class="py-0">
          <v-card flat min-height="800">
            <v-row>
              <v-col cols="12" md="3" class="text-center pa-0 hidden-sm-and-down">
                <div class="pa-0" style="width: 100%; min-height: 700px;">
                  <v-card-text class="py-0 pl-0 pr-0">
                    <v-card-text class="text-second text-left pb-0" style="font-size: 12px;">
                      Anda bisa menambahkan bank baik untuk company atau KPR.
                    </v-card-text>
                    <v-card-text class="text-third text-left" style="font-size: 12px;">
                      Silahkan pilih bank :
                    </v-card-text>

                    <v-list dense class="pa-0 border-item">
                      <v-list-item-group
                        v-model="selected.menu"
                        no-action
                        active-class="white--text">
                        <template v-for="(item, index) in menu">
                          <v-list-item :key="index"
                            :class="{
                              'actived': selected.menu === index
                            }">
                            <template v-slot:default="{ active, toggle }">
                              <v-list-item-content class="pa-0">
                                <v-list-item-title class="text-left text-second caption">
                                  {{ item.label }}
                                </v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </v-list-item>

                          <v-divider/>
                        </template>
                      </v-list-item-group>
                    </v-list>
                  </v-card-text>
                </div>
                <div class="pa-0">
                  <v-divider vertical />
                </div>
              </v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-card-text class="subtitle-2 py-5">
                  Bank
                </v-card-text>
                <v-divider/>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="8" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm' ? 'pb-0':'py-0'">
                      <!-- <v-btn
                        v-if="menu[selected.menu].value === 'company'"
                        color="#4FC3F7"
                        elevation="3"
                        class="text-capitalize white--text"
                        @click="reset()">
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Bank
                      </v-btn> -->
                      <v-btn v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                        :color="style.primary"
                        elevation="3"
                        class="text-capitalize white--text"
                        @click="reset()">
                        <v-icon small class="mr-1">mdi-plus</v-icon>
                        Bank {{ menu[selected.menu].value }}
                      </v-btn>
                    </v-col>
                    <v-col cols="12"  md="4" :class="$vuetify.breakpoint.name === 'xs' || $vuetify.breakpoint.name === 'sm'? 'pb-0':'py-0'">
                      <v-text-field
                        outlined
                        dense
                        :hide-details="true"
                        placeholder="Cari Bank . . ."
                        clearable
                        :color="style.primary"
                        v-model="filter.title"
                        @click:clear="filter.title = ''; fetch();"
                        v-on:keyup.enter="fetch()"
                        prepend-inner-icon="mdi-magnify">
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-divider class="mx-4"/>
                <v-card-text class="py-0" style="min-height: 550px;">
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    type="table-tbody">
                    <v-simple-table>
                      <template v-slot:default>
                        <thead v-if="!process.run && list.length > 0">
                          <tr>
                            <th class="text-left pl-0">Nama Bank</th>
                            <th class="text-left" v-if="menu[selected.menu].value === 'company'">Number</th>
                            <th class="text-left" v-if="menu[selected.menu].value === 'kpr'">Status</th>
                            <th class="text-left" v-if="menu[selected.menu].value === 'company'">Pemilik</th>
                            <th class="text-left"></th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr 
                            v-for="(item, index) in list" 
                            :key="index">
                            <td class="text-second pl-0">
                              <v-list-item class="pa-0">
                                <v-list-item-avatar class="rounded" size="40">
                                  <v-img
                                    contain
                                    :src="menu[selected.menu].value === 'company' ? item.ref_bank_company_bank_image : item.ref_bank_kpr_bank_image">
                                  </v-img>
                                </v-list-item-avatar>

                                <v-list-item-content>
                                  <v-list-item-title class="caption font-weight-bold text-second mb-1">
                                    {{ menu[selected.menu].value === 'company' ? item.ref_bank_company_bank_name : item.ref_bank_kpr_bank_name }}
                                  </v-list-item-title>
                                </v-list-item-content>
                              </v-list-item>
                            </td>
                            <td class="text-second text-capitalize"
                              v-if="menu[selected.menu].value === 'company'">
                              {{ item.ref_bank_company_bank_account_number }}
                            </td>
                            <td class="text-second text-capitalize"
                              v-if="menu[selected.menu].value === 'kpr'">
                              {{ item.ref_bank_kpr_status === '1' ? 'Aktif' : 'Tidak Aktif' }}
                            </td>
                            <td class="text-second text-capitalize"
                              v-if="menu[selected.menu].value === 'company'">
                              {{ item.ref_bank_company_bank_account_name }}
                            </td>
                            <td class="text-right pr-0">
                              <v-btn
                                v-if="menu[selected.menu].value === 'company'"
                                small
                                text
                                min-width="30"
                                class="text-capitalize green--text pa-0 mr-1"
                                @click="reset(item)">
                                <v-icon small>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn
                                v-if="menu[selected.menu].value === 'kpr'"
                                small
                                text
                                min-width="30"
                                class="text-capitalize green--text pa-0 mr-1"
                                :class="item.ref_bank_kpr_status === '1' ? 'grey--text' : 'teal--text'"
                                @click="detail = item; dialog.status = true;">
                                <v-icon small>{{ item.ref_bank_kpr_status === '1' ? 'mdi-upload-off' : 'mdi-upload' }}</v-icon>
                              </v-btn>
                              <v-btn
                                v-if="menu[selected.menu].value === 'company'"
                                small
                                text
                                min-width="30"
                                class="text-capitalize red--text pa-0 mr-1"
                                @click="detail = item; dialog.delete = true;">
                                <v-icon small>mdi-trash-can-outline</v-icon>
                              </v-btn>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-skeleton-loader>
                  <div class="d-flex align-center text-center text--secondary my-12 py-12" style="min-height: 500px;" v-if="!process.run && pagination.total_page < 1">
                    <v-img 
                      class="my-12"
                      contain
                      width="200"
                      height="200"
                      :src="require('../../assets/404/404.svg')">
                    </v-img>
                  </div>
                  <v-divider/>
                </v-card-text>
                <v-card-text :class="$vuetify.breakpoint.name === 'xs' ? 'pt-0':''">
                  <v-row justify="end" align="center" v-if="pagination.total_page > 1">
                    <v-col cols="12" md="2" class="d-flex align-center justify-end">
                      <v-btn
                        :color="style.primary"
                        :disabled="pagination.current === 1"
                        elevation="3"
                        min-width="36"
                        class="text-capitalize white--text px-0 mr-3"
                        @click="selected.pagination = 1">
                        <v-icon>mdi-chevron-double-left</v-icon>
                      </v-btn>
                      <v-btn
                        color="#263238"
                        :disabled="pagination.current < 2"
                        elevation="3"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        @click="selected.pagination = selected.pagination-1">
                        <v-icon>mdi-chevron-left</v-icon>
                      </v-btn>
                      <div class="mx-5" style="width: 75px;">
                        <v-autocomplete
                          v-model="selected.pagination"
                          :items="pagination.detail"
                          color="#263238"
                          auto-select-first
                          outlined
                          dense
                          single-line
                          hide-details
                          hide-selected>
                          <template v-slot:selection="{ item }">
                            {{ item }}
                          </template>
                        </v-autocomplete>
                      </div>
                      <v-btn
                        color="#263238"
                        elevation="3"
                        min-width="36"
                        class="text-capitalize white--text px-0"
                        :disabled="pagination.current >= pagination.total_page"
                        @click="selected.pagination = selected.pagination+1">
                        <v-icon>mdi-chevron-right</v-icon>
                      </v-btn>
                      <v-btn
                        :color="style.primary"
                        :disabled="pagination.current === pagination.total_page"
                        elevation="3"
                        min-width="36"
                        class="text-capitalize white--text px-0 ml-3"
                        @click="selected.pagination = pagination.total_page">
                        <v-icon>mdi-chevron-double-right</v-icon>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    <!-- </v-container> -->

     <div class="v-add-position hidden-md-and-up">
      <v-fab-transition>
        <v-btn 
          class="v-add"
          :color="style.primary"
          rounded
          fixed
          bottom
          right
          fab
          elevation="0"
          @click="sorting.show = true">
          <v-icon color="white">mdi-filter</v-icon>
        </v-btn>
      </v-fab-transition>
    </div>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "../../service/Axios";
  export default {
    data () {
      return {
        dialog: {
          form: false,
          delete: false,
          status: false
        },
        selected: {
          menu: 0,
          pagination: 1
        },
        menu: [
          {
            label: "Bank Company",
            value: "company"
          },
          {
            label: "Bank KPR",
            value: "kpr"
          }
        ],
        sorting: {
          show: false
        },
        filter: {
          title: ''
        },
        page: 1,
        list: [],
        pagination: {},
        detail: {},
        master: [],
        form: {
          company: {
            id: '',
            bank_id: '',
            bank_account_number: '',
            bank_account_name: ''
          },
          kpr: {
            bank_id: ''
          }
        },
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    components: {
      
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      'selected.menu': function(val) {
        this.selected.menu = val === undefined ? 0 : this.selected.menu
        
        this.fetch()
      },
      'selected.pagination': function(val) {
        this.fetch(val)
      }
    },
    mounted () {
      this.fetch()
      this.bank()
    },
    methods: {
      async fetch(p) {
        this.process.run = true

        let params = {
          page: p,
          limit: 10,
          search: this.filter.title
        }

        let api = this.menu[this.selected.menu].value === 'company' ? 'bank-company/list' : 'bank-kpr/list'

        await get(`auth/company/${api}`, { params })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.process.run = false
            this.list = res.data.results
            this.pagination = res.data.pagination
            this.pagination.current = parseInt(this.pagination.current)
          }
        })
      },
      async bank() {
        await get(`site/bank/list`, {
          params: {
            limit: 1000
          }
        })
        .then((response) => {
          let res = response.data
          if (res.status === 200) {
            this.master = res.data.results
          }
        })
      },
      reset(item) {
        this.dialog.form = !this.dialog.form ? true : false
        
        if (this.menu[this.selected.menu].value === 'company') {
          this.form.company = {
            id: item !== undefined ? item.ref_bank_company_id : '',
            bank_id: item !== undefined ? item.ref_bank_company_bank_id : '',
            bank_account_number: item !== undefined ? item.ref_bank_company_bank_account_number : '',
            bank_account_name: item !== undefined ? item.ref_bank_company_bank_account_name : ''
          }
        } else {
          this.form.kpr = {
            bank_id: ''
          }
        }

        this.process.form = false

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          if (this.menu[this.selected.menu].value === 'company') {
            if (this.form.company.id.length < 1) {
              this.creates()
            } else {
              this.updates()
            }
          } else {
            // KPR
            this.createsKPR()
          }
        }
      },
      async creates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/bank-company/form`, {
          data: {
            bank_id: this.form.company.bank_id,
            bank_account_number: this.form.company.bank_account_number,
            bank_account_name: this.form.company.bank_account_name
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async updates() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/bank-company/form`, {
          data: {
            id: this.form.company.id,
            bank_id: this.form.company.bank_id,
            bank_account_number: this.form.company.bank_account_number,
            bank_account_name: this.form.company.bank_account_name
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async deletes() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/bank-company/delete`, {
          data: {
            id: JSON.stringify([this.detail.ref_bank_company_id])
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.delete = false
            this.detail = {}
            this.process.form = false
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      // KPR
      async createsKPR() {
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/bank-kpr/create`, {
          data: {
            bank_id: this.form.kpr.bank_id
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.reset()
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      },
      async statuses() {        
        this.error.message = ''
        this.process.form = true
        await post(`auth/company/bank-kpr/change-status`, {
          data: {
            bank_kpr_id: this.detail.ref_bank_kpr_id,
            status: this.detail.ref_bank_kpr_status === '1' ? '0' : '1'
          }
        }).then(response => {
          let res = response.data
          if (res.status === 200) {
            this.dialog.status = false
            this.detail = {}
            this.process.form = false
            this.fetch()
          } else {
            this.process.form = false
            this.error.message = res.msg
          }
        })
      }
    }
  }
</script>

<style>
.actived {
  background: #f3f3f3;
}
</style>